import { gql } from '@apollo/client';

export const getCounties = gql`
  query getCounties {
    getCounties {
      state
      county
    }
  }
`;
